export const isNullOrUndefinedOrWhitespace = (value)=>{
    return value === null || value === undefined || value.trim().length===0;
}

export const getAlts =(p)=>{
    return [...p.alts,p.text].sort(() => (Math.random() > 0.5) ? 1 : -1)
}